import { I18n } from "@assets/strings";
import React from "react";
import { formatMonthAndYear } from "@utils/date";
import { useIsMobile } from "@utils/hooks";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Stack } from "@ui/components/layout";
import { ApplicationFileInformation } from "@ui/components/application/applicationFileInformation";
import { ApplicationInformationContainer } from "@ui/components/application/applicationInformationContainer";
import { SummaryViewProps } from "@ui/components/application/summaryView";

export const StudyChoiceSummaryView: React.FC<SummaryViewProps> = ({ application, ...htmlProps }) => {
	const isMobile = useIsMobile();

	return (
		<Stack gap={20} style={{ width: "100%", display: "grid" }} {...htmlProps}>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.degree_level.label`)}</PrimaryMedium>
				<ApplicationFileInformation>
					{application.level
						? application.level.name
						: application.levels?.find((level) => level.id === application.levelId)?.name}
				</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.degree_program.label`)}</PrimaryMedium>
				<ApplicationFileInformation>
					{application.degree
						? application.degree.name
						: application.degrees?.find((degree) => degree.id === application.degreeId)?.name}
				</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.credit_points.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.credit}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			{application.desiredStartDate && (
				<ApplicationInformationContainer isDocument={isMobile}>
					<PrimaryMedium>{I18n.t(`application.form.desired_date.label`)}</PrimaryMedium>
					<ApplicationFileInformation>{formatMonthAndYear(application.desiredStartDate)}</ApplicationFileInformation>
				</ApplicationInformationContainer>
			)}
		</Stack>
	);
};
